import { render, staticRenderFns } from "./FormUserBasicInfo.vue?vue&type=template&id=3569f8c6&"
import script from "./FormUserBasicInfo.vue?vue&type=script&lang=js&"
export * from "./FormUserBasicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports